import { getSelectedProjectId, getLastKnownBounds } from 'owa-timestream-store';
import getStore from '../store';

export default function getZoomValues(nextZoom: number): { zoom: number; x: number; y: number } {
    const projectId = getSelectedProjectId();
    const { selectedAssets, canvasBounds, pan, zoom } = getStore();

    // calculate the center point of the document & translate it to it's canvas point
    const docMidpointX = ((canvasBounds.left + canvasBounds.width) / 2 - pan.x) / zoom;
    const docMidpointY = ((canvasBounds.top + canvasBounds.height) / 2 - pan.y) / zoom;
    const nextPanX = (zoom - nextZoom) * docMidpointX + pan.x;
    const nextPanY = (zoom - nextZoom) * docMidpointY + pan.y;
    const midpointZoomValues = { zoom: nextZoom, x: nextPanX, y: nextPanY };

    if (!selectedAssets || !canvasBounds) {
        return midpointZoomValues;
    }

    if (selectedAssets.length >= 1) {
        const selectedAssetsBounds = selectedAssets
            .map(asset => getLastKnownBounds(projectId, asset))
            .filter(bound => !!bound) as {
            x: number;
            y: number;
            width: number;
            height: number;
        }[];
        const assetsMidpoint = calculateMidpoint(selectedAssetsBounds);
        const nextPanX = (zoom - nextZoom) * assetsMidpoint.x + pan.x;
        const nextPanY = (zoom - nextZoom) * assetsMidpoint.y + pan.y;
        return { zoom: nextZoom, x: nextPanX, y: nextPanY };
    }

    return midpointZoomValues;
}
function calculateMidpoint(
    points: { x: number; y: number; width: number; height: number }[]
): { x: number; y: number } {
    const xSum = points.reduce((acc, point) => acc + (point.x + point.width / 2), 0);
    const ySum = points.reduce((acc, point) => acc + (point.y + point.height / 2), 0);
    return { x: xSum / points.length, y: ySum / points.length };
}
